import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { AlertsService } from '../../../../../../../shared/services/alerts.service';
import { NgbDate, NgbDatepicker, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { DatosPersona, IEstadoSancion, SancionesPersonasSharedModel } from '../sanciones-personas/sanciones-persona.interface';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { AccionesSancionesEnum, EstadosSancionesEnum } from '../sanciones-personas/sanciones-persona.enum';
import { EstablecimientoComercioService } from '../../../prestador/establecimiento-comercio/establecimiento-comercio.service';
import { SancionesPersonasService } from '../sanciones-personas/sanciones-personas.service';
import { AsignarSancionesPersonasService } from './asignar-sanciones-persona.service';
import { ModalValidarRenovacionComponent } from 'src/app/components/core/layouts/modal-validar-renovacion/modal-validar-renovacion.component';
import { DatePipe } from '@angular/common';
import { ConfirmarRespuestaModel, ConfirmarRespuestaType, TipoConfirmacionModalType } from 'src/app/shared/models/confirmar-respuesta.model';
import { ModalConfirmarRespuestaComponent } from 'src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component';

@Component({
  selector: 'app-asignar-sanciones-persona',
  templateUrl: './asignar-sanciones-persona.component.html',
  styleUrls: ['./asignar-sanciones-persona.component.scss']
})
export class AsignarSancionesPersonaComponent implements OnInit {
  formAsignacion!: FormGroup;
  formRnt !: FormGroup;
  paginaActual: number = 1;
  @ViewChild('inicio') fechaInicio: NgbDatepicker;
  id_asignacion = AccionesSancionesEnum.asignar;
  id_edicion    = AccionesSancionesEnum.editar;
  id_eliminar    = AccionesSancionesEnum.eliminar;
  sharedModel: SancionesPersonasSharedModel;
  showRnt: boolean = false;
  extensiones = ["application/pdf"];
  fecha_inicio: any;
  estadosSanciones: any[]=[];
  estados_sanciones: Array<IEstadoSancion>;
  headersRnt: Array<string>;
  dataTabla :any;
  arrayItemsRnt: any;
  file: File = null;
  constructor(private formBuilder: FormBuilder,
              private alertService: AlertsService,
              private router: Router,
              private datePipe: DatePipe,
              private dataSharedService:DataSharedService,
              private modalService: NgbModal,
              private establecimientoComercioService: EstablecimientoComercioService,
              private sancionesPersonasService: SancionesPersonasService,
              private AsignarSancionesPersonasService: AsignarSancionesPersonasService) {
                
    this.getEstadosSanciones();
    this.initForm();
    this.haveToShowRnt();
    this.dataSharedService.data$.subscribe(response =>{
      if(response != ' '){
        this.sharedModel = response;
        if(!(this.sharedModel.datosPersona.persona_id > 0)){
          this.router.navigate(["/admin/sanciones-personas"]);
        }
      }else{
        this.router.navigate(["/admin/sanciones-personas"]);
      }
    });
  }
  disableAllControls(): void{
    for (var control in this.formAsignacion.controls) {
      this.formAsignacion.controls[control].disable();
    }
  }
  ngOnInit(): void {
    this.headersRnt = ['Seleccionar','Número RNT', 'NIT', 'Tipo RNT', 'Nombre del Establecimiento',
                        'Cámara de Comercio','Dirección','Subcategoría','Fecha de Inscripción',
                        'Último año Renovado','Estado RNT','Sanciones',];
    if(this.sharedModel.tipo === AccionesSancionesEnum.editar){
      this.getSancionById();
      this.getListadoRnt();    
    }
  }
  correctDate(date: string) {
    const correctDate = new Date(date);
    return correctDate.toISOString().substring(0,10);
  }
  getSancionById(): void{
    this.AsignarSancionesPersonasService
        .getById(this.sharedModel.datosPersona.sancion_id)
        .subscribe(response=>{
          this.formAsignacion.setValue(
            {
              numero_resolucion                      : response.data.numero_resolucion,
              fecha_exp_acto_admin                   : this.correctDate(response.data.fecha_exp_acto_admin),
              valor_uvt                              : response.data.valor_uvt,
              fecha_eje_acto_admin                   : this.correctDate(response.data.fecha_eje_acto_admin),
              sancion_estado_id                      : response.data.sancion_estado_id,
              texto_certificado                      : response.data.texto_certificado,
              motivo_sancion                         : response.data.motivo_sancion,
              archivo                                : response.data.archivo,
              decreto_1836                           : response.data.decreto_1836,
              fecha_inicial                          : new Date(response.data.fecha_inicial),
              fecha_final                            : new Date(response.data.fecha_final),
              incumplimiento_presentacion_servicio   : null,
              cierre_empresa_obligaciones            : null,
              persona_id                             : response.data.persona_id,
            }
          );
          if(response.data.nombre_archivo != null){
            this.file = new File([],response.data.nombre_archivo);
          }
          if(response.data.listado_rnt_string != null){
            this.arrayItemsRnt = response.data.listado_rnt_string.split(',');
          }
          this.validateActionsByStatus(response.data.sancion_estado_id);
        });
  }

 
  validateActionsByStatus(id_status: number):void{
    switch(id_status){
      case EstadosSancionesEnum.Activo:
          const control1 = this.formAsignacion.get('sancion_estado_id');
          control1.setValue(EstadosSancionesEnum.Activo);
          control1.disable();
        break;
      case EstadosSancionesEnum.Innactivo:
        const control2 = this.formAsignacion.get('sancion_estado_id');
          control2.enable();
          control2.setValue(null);
          this.estados_sanciones=this.estados_sanciones.filter(x=>x.sancion_estado_id == EstadosSancionesEnum.Activo);
        break;
      case EstadosSancionesEnum.Eliminado:
        this.disableAllControls();
        break;
    }
  }
  getListadoRnt(): void{
    if(this.showRnt){

      this.AsignarSancionesPersonasService
          .getRntAsociado(
            {
              persona_id:this.sharedModel.datosPersona.persona_id,
              numero_rnt:this.formRnt.value.numero_rnt,
              sancion_id:null,
            },
            this.paginaActual
          ).subscribe(response =>{
            this.dataTabla = response.data;
            this.dataTabla?.items.forEach(element => {
              if(this.arrayItemsRnt?.includes(element.rnt_id.toString())){
                element.activo = true;
              }
          });
        });
    }
  }
  getEstadosSanciones(): void{
    this.sancionesPersonasService
        .getEstadosSanciones()
        .subscribe( response =>{
          if(response.result){
            this.estados_sanciones = response.data as Array<IEstadoSancion>;
          }
        })
  }
  haveToShowRnt(): void{
      this.establecimientoComercioService
          .getParametro({
            parametro_id:'SANCIONES_PERSONAS_APLICA_A_RNT',
            agrupacion:'SANCIONES_PERSONAS',
            auxiliar:'1',
          }).subscribe((response) => {
              if (response.result) {
                if(response.data == 'Si'){
                  this.showRnt = true;
                }
              }
              this.getListadoRnt();
              if(this.sharedModel.tipo === AccionesSancionesEnum.editar){
                this.getSancionById();
              }
              this.disableTextoCertificado();
              if(this.sharedModel){
                this.formAsignacion.get('persona_id').setValue(this.sharedModel.datosPersona.persona_id);  
                if(this.sharedModel.tipo === AccionesSancionesEnum.asignar){
                  this.formAsignacion.get('sancion_estado_id').setValue(1);
                }
              }
          }
      );
  }
  
  initForm(): void{
    this.formAsignacion = this.formBuilder.group({
      numero_resolucion                      :['',Validators.required],
      fecha_exp_acto_admin                   :['',Validators.required],
      valor_uvt                              :[null],
      fecha_eje_acto_admin                   :['',Validators.required],
      sancion_estado_id                      :[{value:'',disabled: true},Validators.required],
      texto_certificado                      :[''],
      motivo_sancion                         :['',Validators.required],
      archivo                                :['',],
      decreto_1836                           :[false],
      fecha_inicial                          :['',Validators.required],
      fecha_final                            :[null],
      incumplimiento_presentacion_servicio   :['',],
      cierre_empresa_obligaciones            :['',],
      persona_id                             :[''],
    });
    this.formRnt = this.formBuilder.group({
      numero_rnt  :[]
    });
    if(this.sharedModel){
      this.formAsignacion.get('persona_id').setValue(this.sharedModel.datosPersona.persona_id);  
      if(this.sharedModel.tipo === AccionesSancionesEnum.asignar){
        this.formAsignacion.get('sancion_estado_id').setValue(1);
      }
    }
    
  }
  disableTextoCertificado(): void{
    let texto_certificado = this.formAsignacion.get('texto_certificado');
    if(this.showRnt){
      texto_certificado.enable();
    }else{
      texto_certificado.disable();
    }
  }
  resetCheckbox(): void{
    if(!this.formAsignacion.get('decreto_1836').value){
        this.formAsignacion.get('incumplimiento_presentacion_servicio').setValue(false);
        this.formAsignacion.get('cierre_empresa_obligaciones').setValue(false);
    }
  }
  onSubmit(): void{
    if(this.formAsignacion.valid){
      if(this.sharedModel.tipo === AccionesSancionesEnum.editar){
        this.onEditarSancion();
      }else{
        if(this.file != null){
          this.crearSancion();
        }
      }  
    }
  }
  getParam({parametro_id,agrupacion,auxiliar}): void{
    this.establecimientoComercioService
        .getParametro({
          parametro_id,
          agrupacion,
          auxiliar,
        })
          .subscribe(
            (resultado2) => {
              if (resultado2.result) {
                const modalAceptarRenovacion = this.modalService.open(
                  ModalValidarRenovacionComponent,
                  { centered: true, backdrop: "static", size: "md" }
                );
                modalAceptarRenovacion.componentInstance.mensaje =
                  resultado2.data;
              }
            },
            (error) => {
            }
          );
  }
  onEditarSancion(): void{
    this.establecimientoComercioService
          .getParametro({
            parametro_id:'ADVERTENCIA_CONFIRMAR_CAMBIOS_SANCION_PERSONA',
            agrupacion:'VALIDACIONES',
            auxiliar:'1',
          }).subscribe((response) => {
              if (response.result) {
                let data: any = {
                  imagen: '',
                  type: ConfirmarRespuestaType.Atencion,
                  tipoConfirmacionModalType: TipoConfirmacionModalType.Confirmacion,
                  message: response.data
                };
                const modal = this.modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
                modal.componentInstance.confirmarRespuesta = data;
                modal.result.then(()=>{
                  this.editarSancion();
                });
              }
          }
      );
    
  }
  editarSancion(): void{
    
    let fecha_inicial=null, fecha_final=null;
    if(this.formAsignacion.get('fecha_inicial').value != '' && this.formAsignacion.get('fecha_inicial').value != null){
      fecha_inicial= new Date(this.formAsignacion.get('fecha_inicial').value).toISOString();
    }
    if(this.formAsignacion.get('fecha_final').value != '' && this.formAsignacion.get('fecha_final').value != null){
      fecha_final= new Date(this.formAsignacion.get('fecha_final').value).toISOString();
    }
    let listado_rnt:string='';
    if(this.dataTabla?.items){
      listado_rnt=JSON.stringify(this.dataTabla.items.filter(x=> x.activo)) 
    };
    this.AsignarSancionesPersonasService
        .editarSancion({
          ...this.formAsignacion.getRawValue(),
          fecha_inicial,
          fecha_final,
          listado_rnt,
          sancion_id : this.sharedModel.datosPersona.sancion_id
        },this.file)
        .subscribe( response => {
          if(response.status === 200 && response.body.data != null){
            this.getParam({
              parametro_id:'ADVERTENCIA_SANCION_PERSONA_ACTUALIZACION_CORRECTA',
              agrupacion:'VALIDACIONES',
              auxiliar: 1
            });
            this.router.navigate(["/admin/sanciones-personas"]);
          }
    });
  }
  crearSancion(): void{
    let fecha_inicial=null, fecha_final=null;
    if(this.formAsignacion.get('fecha_inicial').value != '' && this.formAsignacion.get('fecha_inicial').value != null){
      fecha_inicial= new Date(this.formAsignacion.get('fecha_inicial').value).toISOString();
    }
    if(this.formAsignacion.get('fecha_final').value != '' && this.formAsignacion.get('fecha_final').value != null){
      fecha_final= new Date(this.formAsignacion.get('fecha_final').value).toISOString();
    }
    let listado_rnt:string='';
    if(this.dataTabla?.items){
      listado_rnt=JSON.stringify(this.dataTabla.items.filter(x=> x.activo)) 
    };
    
    this.AsignarSancionesPersonasService
        .crearSancion(
          {
            ...this.formAsignacion.getRawValue(),
            fecha_inicial,
            fecha_final,
            listado_rnt
          },this.file)
        .subscribe( response => {
          if(response.status === 200 && response.body.result){
            this.getParam({
              parametro_id:'ADVERTENCIA_SANCION_PERSONA_CREACION_CORRECTA',
              agrupacion:'VALIDACIONES',
              auxiliar: 1
            });
            this.router.navigate(["/admin/sanciones-personas"]);
          }
      
    });
  }
  onPaginado(value: number) {
		this.paginaActual = value;
    this.getListadoRnt();
		
	}
  clearList(): void{
    this.formRnt.reset();
    this.paginaActual = 1;
    this.getListadoRnt();
  }
  onExit(): void{
    this.router.navigate(["/admin/sanciones-personas"]);
  }
  onFileInput(eventFile) {
    const tempo = eventFile.target.files as FileList;
    const file = tempo.item(0);

    if (tempo.item.length > 0) {
      if (this.extensiones.indexOf(file.type) < 0) {
        this.alertService.warn(
          "Solo se permite archivos con extensión .pdf",
          "",
          "sin-codigo"
        );
        this.cancel();
        return false;
      } else if (file.size / 1024 / 1024 > 15) {
        this.alertService.warn(
          "Ha superado el tamaño máximo permitido (15Mb)",
          "",
          "sin-codigo"
        );
        this.cancel();
        return false;
      } else {
        this.file = tempo.item(0);
        this.formAsignacion.value.archivo = tempo.item(0);
      }
    }
  }
  cancel() {
    if(this.sharedModel.tipo === AccionesSancionesEnum.editar){
      this.alertService.warn(
        "No es permitido eliminar archivos en edición",
        "",
        "sin-codigo"
      );      
    }
    else
    {
      this.formAsignacion.controls["archivo"].setValue(null);
      this.file = null;
    }
  }
  onCheckDate(minDate: NgbDate) {
    const currentDate = new Date();
    const minDateJs = new Date(minDate.year,minDate.month-1,minDate.day);
    if(minDateJs.getDate() < currentDate.getDate()){
      this.fecha_inicio = { day: currentDate.getDate(), month: currentDate.getMonth()+1, year: currentDate.getFullYear() };  
    }else{
      this.fecha_inicio = { day: minDate.day, month: minDate.month, year: minDate.year };  
    }
	}
  get decreto1836Label(): string{
    return "Aplica sanción de 5 años, de acuerdo con el DECRETO 1836 del 24 De Diciembre del 2021, articulo 31.";
  }
  get incumplimientoLabel(): string{
    return "Incumplimiento con la prestación total del servicio y no reembolse el dinero a los usuarios.";
  }
  get cierreLabel(): string{
    return "Cierre o desaparición de la empresa sin atender sus obligaciones.";
  }
  get decreto_1836(){
    return this.formAsignacion.get('decreto_1836').value
  }

}
